// Funciones tipadas contra el contrato. Endpoints /me/... (perfil por sesión).
import { apiGet } from "./client";
import type { EditionsList, PulseEdition, WeeklyFeature } from "@/types";

export interface PulseProfileOption {
  slug: string;
  name: string;
}

export interface PulseProfilesResponse {
  active_slug: string;
  profiles: PulseProfileOption[];
}

interface PulseRequestOptions {
  profileSlug?: string;
}

function withProfile(path: string, profileSlug?: string): string {
  if (!profileSlug) return path;
  return `${path}?profile=${encodeURIComponent(profileSlug)}`;
}

export function getPulseProfiles(profileSlug?: string): Promise<PulseProfilesResponse> {
  return apiGet<PulseProfilesResponse>(withProfile("/pulse/me/profiles", profileSlug));
}

export function getLatest(options: PulseRequestOptions = {}): Promise<PulseEdition> {
  return apiGet<PulseEdition>(withProfile("/pulse/me/latest", options.profileSlug));
}

export function getEditions(options: PulseRequestOptions = {}): Promise<EditionsList> {
  return apiGet<EditionsList>(withProfile("/pulse/me/editions", options.profileSlug));
}

export function getEdition(fecha: string, options: PulseRequestOptions = {}): Promise<PulseEdition> {
  return apiGet<PulseEdition>(withProfile(`/pulse/me/${fecha}`, options.profileSlug));
}

export function getWeeklyFeatures(limit = 3, options: PulseRequestOptions = {}): Promise<WeeklyFeature[]> {
  const base = `/pulse/me/weekly-features?limit=${limit}`;
  if (!options.profileSlug) return apiGet<WeeklyFeature[]>(base);
  return apiGet<WeeklyFeature[]>(`${base}&profile=${encodeURIComponent(options.profileSlug)}`);
}
